import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/DocumentsCollector';

export interface IDocument {
  id: number;
  name: string;
  subjectName: string;
  typeId: number;
  documentDate: string;
  requestNumber?: string;
  linkedRequestNumbers?: string[];
}

interface IGetDocumentsQuery {
  fromDate?: string;
  toDate?: string;
  searchText?: string;
  isSentToUser?: boolean;
  subject?: IDocumentSubject[];
}

export interface IDocumentType {
  id: number;
  name: string;
  subject?: string;
  isSentToUser: boolean;
  infoDescription?: string;
  infoLinkText?: string;
  infoLink?: string;
}

export interface IDocumentSubject {
  documentTypeId: number;
  subjectName: string;
}

export interface IDocumentFile {
  id: number;
  type: number;
  contentBase64: string;
}

export const getDocuments = async (queryString?: IGetDocumentsQuery) => {
  const buildQuery = (queryString: IGetDocumentsQuery): string => {
    const queryParts: string[] = [];

    if (queryString.fromDate)
      queryParts.push(`FromDate=${queryString.fromDate}`);
    if (queryString.toDate) queryParts.push(`toDate=${queryString.toDate}`);
    if (queryString.searchText)
      queryParts.push(`SearchText=${queryString.searchText}`);
    if (queryString.isSentToUser !== undefined)
      queryParts.push(`IsSentToUser=${queryString.isSentToUser}`);
    if (queryString.subject && queryString.subject.length > 0) {
      queryString.subject.forEach((item, index) => {
        queryParts.push(
          `subject[${index}].DocumentTypeId=${item.documentTypeId}`
        );
        queryParts.push(
          `subject[${index}].SubjectName=${encodeURIComponent(
            item.subjectName
          )}`
        );
      });
    }
    return queryParts.join('&');
  };

  let result;
  if (queryString) {
    const query = buildQuery(queryString);
    result = await api.get<IDocument[]>(
      addImposterToUrl(`${baseURL}?${query}`, false)
    );
  } else {
    result = await api.get<IDocument[]>(addImposterToUrl(`${baseURL}`, true));
  }

  if (result) return result.data;
};

export const getDocumentTypes = async () => {
  const result = await api.get<IDocumentType[]>(
    addImposterToUrl(`${baseURL}/Types`, true)
  );
  if (result) return result.data;
};

export const getDocumentSubject = async () => {
  const result = await api.get<IDocumentSubject[]>(
    addImposterToUrl(`${baseURL}/GetSubjects`, true)
  );
  if (result) return result.data;
};

export const GetDocumentFile = async (type: number, id: number) => {
  const result = await api.get<IDocumentFile>(
    addImposterToUrl(`${baseURL}/${type}/${id}`, true)
  );
  if (result) return result.data;
};

export const getDocumentsPastYears = async () => {
  const result = await api.get<number[]>(
    addImposterToUrl(`${baseURL}/PastYears`, true)
  );
  if (result) return result.data;
};
